module.exports = __webpack_public_path__ + "static/media/arrow-left.4c0407e9.svg";